import { render, staticRenderFns } from "./AddEditMOT.vue?vue&type=template&id=e8dea0e2&"
import script from "./AddEditMOT.vue?vue&type=script&lang=js&"
export * from "./AddEditMOT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports